import axios from 'axios'

/**
 * 
 * @status no delete
 * @class PermissionService
 */
class PermissionService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Developer
  * @description Get all permissions
  * @date 19-02-2026
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async getAllPermissions(id, token,filter) {
    let response = await axios.get(`${this.apiUrl}/permissions-passthrough?clientId=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data.data
  }

  /**
  * @author Developer
  * @description Get permissions by role id
  * @date 19-02-2026
  * @param {Number} roleId
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async getPermissionsByRoleId(roleId, token) {
    let response = await axios.get(`${this.apiUrl}/permissions-passthrough?roleId=${roleId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
  * @author Developer
  * @description Get permissions by user id
  * @date 19-02-2026
  * @param {Number} userId
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async getPermissionsByUserId(userId, token) {
    let response = await axios.get(`${this.apiUrl}/permissions-passthrough?userId=${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

    async getUsersByPermission(id, token) {
    let response = await axios.get(`${this.apiUrl}/user-by-permission-passthrough?id=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
  * @author Developer
  * @description Delete a permission
  * @date 20-02-2026
  * @param {Number} id
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async deletePermission(id, token) {
    let response = await axios.delete(`${this.apiUrl}/permission-passthrough?id=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
    /**
* @author Lucia Alvarado
* @description Update a domain
* @date 12-03-2021
* @status no delete
* @param {String} token
* @param {String} domain
* @param {Number} clientId
* @param {Number} id
* @returns {Object}
* @memberof PermissionService
*/
  async updatePermission(clientId, description, id, name, usersToAdd, usersToRemove, token) {
    let response = await axios.put(`${this.apiUrl}/permission-passthrough`,
      { clientId, description, id, name, usersToAdd, usersToRemove },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }


  /**
  * @author Developer
  * @description Create a permission
  * @date 20-02-2026
  * @param {String} name
  * @param {String} description
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async createPermission(name, description,typeId,clientId, key, token) {
    let response = await axios.post(`${this.apiUrl}/permission-passthrough`,
      { name, description, typeId, clientId, key },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

    return response.data
  }

    /**
  * @author Developer
  * @description Create a permission
  * @date 20-02-2026
  * @param {String} clientId
  * @param {String} token
  * @returns {Object}
  * @memberof PermissionService
  */
  async getUserByClientId(clientId, token) {
    let response = await axios.get(`${this.apiUrl}/user-by-client-id-passthrough?clientId=${clientId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })

    return response.data
  }

}

export { PermissionService as default }
